<section class="login-page">
  <div class="login-page-wrapper">
    <div class="login-card card">
      <div class="section1">
        <div class="logoImgBox">
          <img src="../../../assets/new-dash/logo/revenuedLogo_black.png" class="logoImg" alt="Revenued Logo" />
        </div>
        <div class="formBox">
          <h1 class="welcomeTitle">
            Hello! Welcome back.
          </h1>
          <form [formGroup]="loginForm" id="form" (ngSubmit)="sendMFACode()">
            <mat-form-field appearance="outline" class="myMatFormField">
              <!-- Add 'invalid' to the class of mat-form-field for invalid inputs -->
              <!-- <mat-label [class.field-focus]="isEmailFocussed"></mat-label> -->

              <img matPrefix src="../../../assets/new-dash/login/emailIcon.png" class="iconBox" alt="Email icon" />
              <input matInput placeholder="Email Address" formControlName="email" type="email" required
                name="Email Address" [readonly]="loggedIn" (focus)="emailOnFocus()" (focusout)="emailOnFocusOut()"
                aria-label="Please enter your email address. This is a required field.">
              <mat-error *ngIf="email?.invalid">{{getEmailErrorMessage()}}
              </mat-error>

              <!-- <mat-hint class="help-text">Please enter your email address</mat-hint> -->
            </mat-form-field>

            <mat-form-field appearance="outline" class="myMatFormField">
              <!-- Add 'invalid' to the class of mat-form-field for invalid inputs -->
              <!-- <mat-label [class.field-focus]="isPwdFocussed"></mat-label> -->
              <img matPrefix src="../../../assets/new-dash/login/pwdIcon.svg" class="iconBox" alt="Password icon" />
              <input matInput placeholder="Password" formControlName="password"
                [type]="fieldTextType ? 'text' : 'password'" [readonly]="loggedIn" required (focus)="pwdOnFocus()"
                (focusout)="pwdOnFocusOut()" aria-label="Please enter your password. This is a required field.">
              <i matSuffix class="fa mouse-pointerz iconBoxSuffix" [ngClass]="{
                  'fa-eye-slash': !fieldTextType,
                  'fa-eye': fieldTextType
                }" (click)="toggleFieldTextType()"></i>
              <mat-error *ngIf="password?.invalid">{{getPwdErrorMessage()}}
              </mat-error>
              <!-- <mat-hint class="help-text">Please enter your password</mat-hint> -->
            </mat-form-field>

            <!-- <mat-error *ngIf="!loginForm.valid">Invalid credentials entered</mat-error> -->
            <div>
              <button class="primary-general-btn w-100" [disabled]="!loginForm.valid"
                [ngClass]="{'disabled':!loginForm.valid}" matRipple>
                <div *ngIf="(loggedIn && loginForm.valid); else generalCondition">
                  <app-loader></app-loader>
                </div>
                <ng-template #generalCondition>
                  <span>Login</span>
                </ng-template>
              </button>
              <mat-error *ngIf="loginError" class="mainError">
                <span *ngIf="!isNetworkError">Username and/or password incorrect</span>
                <span *ngIf="isNetworkError">We’re sorry, but your request was blocked due to security restrictions.
                  Please try again later or contact support if the problem continues.</span>
              </mat-error>
              <mat-error *ngIf="verifyIdentiryFailMessage" class="mainError">{{verifyIdentiryFailMessage}}
              </mat-error>
            </div>
          </form>
          <div class="bottom-action-links">
            <a href="javascript:void(0);" routerLink="/forgot-password" class="link-items">
              Forgot Password?
            </a>
            <a href="javascript:void(0);" routerLink="/verify-identity" class="link-items" *ngIf="false">
              Verify Identity
            </a>
            <a href="javascript:void(0);" routerLink="/verify-code" class="link-items otpLogin" *ngIf="false">
              Using MFA Code?
            </a>
          </div>
        </div>
      </div>
      <div class="section2">
        <div class="inner-div">
          <!-- <p class="content">
            A card that cares less about FICO and more about your business
          </p> -->
        </div>
      </div>
    </div>
    <footer class="footer--login">
      <div class="footerMenu">
        <a href="https://www.revenued.com/about/" class="footerMenuLink" target="_blank">
          About Revenued
        </a>
        <a href="https://www.revenued.com/contact/" class="footerMenuLink" target="_blank">
          Contact Us
        </a>
        <a href="https://www.revenued.com/revenued-cardholder-agreement/" class="footerMenuLink" target="_blank">
          Card User Agreement
        </a>
        <a href="https://www.revenued.com/terms" target="_blank" class="footerMenuLink">
          Terms of Service
        </a>
        <a href="https://www.revenued.com/privacy-policy" target="_blank" class="footerMenuLink">
          Privacy Policy
        </a>
      </div>
    </footer>
  </div>
  <!-- <div class="bgImage"></div> -->
</section>

<!-- Admin Widget -->
<button *ngIf="showAdminWidget" class="toggleAdminWidgetBtn loginPageWidgetBtn"
  (click)="adminWidgetDrawer.toggleSidebar()" [class.toggleBtn-hide]="adminWidgetDrawer.isOpen"
  [attr.aria-label]="isToggleAdminFlagOpen ? 'Close widget sidebar' : 'Open widget sidebar'" type="button">
  <mat-icon>keyboard_arrow_left</mat-icon>
</button>
<app-admin-widget customClass="loginPageWidget" #adminWidgetDrawer></app-admin-widget>


<!-- Mock Server Indicator -->
<div class="authServerstatusWrapper" *ngIf="showAdminWidget">
  <div [ngClass]="{'inactive': !mockServerActive}" class="innerWrapper">
    <div class="pulseIndicatorDot" *ngIf="mockServerActive">
    </div>
    <div>
      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
        [attr.stroke]="mockServerActive ? '#ffffff' : '#6c757d'" stroke-width="2" stroke-linecap="round"
        stroke-linejoin="round" class="lucide lucide-server w-3 h-3 mr-1.5" __v0_r="0,918,934">
        <rect width="20" height="8" x="2" y="2" rx="2" ry="2"></rect>
        <rect width="20" height="8" x="2" y="14" rx="2" ry="2"></rect>
        <line x1="6" x2="6.01" y1="6" y2="6"></line>
        <line x1="6" x2="6.01" y1="18" y2="18"></line>
      </svg>
      <span>
        Mock Server: {{ mockServerActive ? 'Active' : 'Inactive' }}
      </span>
    </div>
  </div>
</div>